import { NotificationTypeEnum } from './notification-type-enum';
import { SnackbarConfig } from './snackbar-config';

export class NotificationMessage {
  public type: NotificationTypeEnum;
  public text: string;
  public snackbarConfig: SnackbarConfig = null;
  public status = 'success';

  constructor(type: NotificationTypeEnum, text: string, snackbarConfig?: SnackbarConfig) {
    this.type = type;
    this.text = text;
    this.snackbarConfig = snackbarConfig;
  }
}
